/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AccessoryDto } from '../models/accessory-dto';
import { CalculationDto } from '../models/calculation-dto';
import { CustomAccessoriesDto } from '../models/custom-accessories-dto';
import { CustomCalculateTilesDto } from '../models/custom-calculate-tiles-dto';
import { CustomCalculateTilesResponseDto } from '../models/custom-calculate-tiles-response-dto';
import { CustomCalculationDto } from '../models/custom-calculation-dto';
import { CustomRoofDto } from '../models/custom-roof-dto';
import { CustomShapeCalculationDto } from '../models/custom-shape-calculation-dto';
import { CustomShapeRoof } from '../models/custom-shape-roof';
import { CustomShapesAccessoriesDto } from '../models/custom-shapes-accessories-dto';
import { FenceSlatAccessoriesMeasurementsDto } from '../models/fence-slat-accessories-measurements-dto';
import { FenceSlatCalculationDto } from '../models/fence-slat-calculation-dto';
import { FenceSlatDto } from '../models/fence-slat-dto';
import { FourSlope } from '../models/four-slope';
import { FourSlopeAccessoriesMeasurementsDto } from '../models/four-slope-accessories-measurements-dto';
import { FourSlopeCalculationDto } from '../models/four-slope-calculation-dto';
import { OneSlopeAccessoriesMeasurementsDto } from '../models/one-slope-accessories-measurements-dto';
import { OneSlopeCalculationDto } from '../models/one-slope-calculation-dto';
import { OneSlopeDto } from '../models/one-slope-dto';
import { RoofDto } from '../models/roof-dto';
import { SketchesBase64Dto } from '../models/sketches-base-64-dto';
import { TwoSlopeAccessoriesMeasurementsDto } from '../models/two-slope-accessories-measurements-dto';
import { TwoSlopeCalculationDto } from '../models/two-slope-calculation-dto';
import { TwoSlopeDto } from '../models/two-slope-dto';

@Injectable({
  providedIn: 'root',
})
export class CalculationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Path part for operation calculationsControllerTwoSlopeAccessories
   */
  static readonly CalculationsControllerTwoSlopeAccessoriesPath = '/api/calculations/roof/two-slopes/accessories';

  /**
   * Calculate a two slope roof accessories.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerTwoSlopeAccessories()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerTwoSlopeAccessories$Response(
    params: {
      body: TwoSlopeAccessoriesMeasurementsDto;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<AccessoryDto>>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CalculationsService.CalculationsControllerTwoSlopeAccessoriesPath,
      'post',
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<Array<AccessoryDto>>;
        }),
      );
  }

  /**
   * Calculate a two slope roof accessories.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerTwoSlopeAccessories$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerTwoSlopeAccessories(
    params: {
      body: TwoSlopeAccessoriesMeasurementsDto;
    },
    context?: HttpContext,
  ): Observable<Array<AccessoryDto>> {
    return this.calculationsControllerTwoSlopeAccessories$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AccessoryDto>>) => r.body as Array<AccessoryDto>),
    );
  }

  /**
   * Path part for operation calculationsControllerFourSlopeAccessories
   */
  static readonly CalculationsControllerFourSlopeAccessoriesPath = '/api/calculations/roof/four-slopes/accessories';

  /**
   * Calculate a one slope roof accessories.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerFourSlopeAccessories()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerFourSlopeAccessories$Response(
    params: {
      body: FourSlopeAccessoriesMeasurementsDto;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<AccessoryDto>>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CalculationsService.CalculationsControllerFourSlopeAccessoriesPath,
      'post',
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<Array<AccessoryDto>>;
        }),
      );
  }

  /**
   * Calculate a one slope roof accessories.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerFourSlopeAccessories$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerFourSlopeAccessories(
    params: {
      body: FourSlopeAccessoriesMeasurementsDto;
    },
    context?: HttpContext,
  ): Observable<Array<AccessoryDto>> {
    return this.calculationsControllerFourSlopeAccessories$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AccessoryDto>>) => r.body as Array<AccessoryDto>),
    );
  }

  /**
   * Path part for operation calculationsControllerCustomShapeAccessories
   */
  static readonly CalculationsControllerCustomShapeAccessoriesPath = '/api/calculations/roof/custom-shape/accessories';

  /**
   * Calculate a custom shape roof accessories.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerCustomShapeAccessories()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerCustomShapeAccessories$Response(
    params: {
      body: CustomShapesAccessoriesDto;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<AccessoryDto>>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CalculationsService.CalculationsControllerCustomShapeAccessoriesPath,
      'post',
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<Array<AccessoryDto>>;
        }),
      );
  }

  /**
   * Calculate a custom shape roof accessories.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerCustomShapeAccessories$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerCustomShapeAccessories(
    params: {
      body: CustomShapesAccessoriesDto;
    },
    context?: HttpContext,
  ): Observable<Array<AccessoryDto>> {
    return this.calculationsControllerCustomShapeAccessories$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AccessoryDto>>) => r.body as Array<AccessoryDto>),
    );
  }

  /**
   * Path part for operation calculationsControllerCustomAccessories
   */
  static readonly CalculationsControllerCustomAccessoriesPath = '/api/calculations/roof/custom/accessories';

  /**
   * Calculate a custom roof accessories.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerCustomAccessories()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerCustomAccessories$Response(
    params: {
      body: CustomAccessoriesDto;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<AccessoryDto>>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CalculationsService.CalculationsControllerCustomAccessoriesPath,
      'post',
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<Array<AccessoryDto>>;
        }),
      );
  }

  /**
   * Calculate a custom roof accessories.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerCustomAccessories$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerCustomAccessories(
    params: {
      body: CustomAccessoriesDto;
    },
    context?: HttpContext,
  ): Observable<Array<AccessoryDto>> {
    return this.calculationsControllerCustomAccessories$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AccessoryDto>>) => r.body as Array<AccessoryDto>),
    );
  }

  /**
   * Path part for operation calculationsControllerOneSlopeCalculator
   */
  static readonly CalculationsControllerOneSlopeCalculatorPath = '/api/calculations/roof/one-slope';

  /**
   * Calculate a one slope roof.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerOneSlopeCalculator()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerOneSlopeCalculator$Response(
    params: {
      body: OneSlopeDto;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<OneSlopeCalculationDto>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CalculationsService.CalculationsControllerOneSlopeCalculatorPath,
      'post',
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<OneSlopeCalculationDto>;
        }),
      );
  }

  /**
   * Calculate a one slope roof.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerOneSlopeCalculator$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerOneSlopeCalculator(
    params: {
      body: OneSlopeDto;
    },
    context?: HttpContext,
  ): Observable<OneSlopeCalculationDto> {
    return this.calculationsControllerOneSlopeCalculator$Response(params, context).pipe(
      map((r: StrictHttpResponse<OneSlopeCalculationDto>) => r.body as OneSlopeCalculationDto),
    );
  }

  /**
   * Path part for operation calculationsControllerOneSlopeAccessories
   */
  static readonly CalculationsControllerOneSlopeAccessoriesPath = '/api/calculations/roof/one-slope/accessories';

  /**
   * Calculate a one slope roof accessories.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerOneSlopeAccessories()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerOneSlopeAccessories$Response(
    params: {
      body: OneSlopeAccessoriesMeasurementsDto;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<AccessoryDto>>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CalculationsService.CalculationsControllerOneSlopeAccessoriesPath,
      'post',
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<Array<AccessoryDto>>;
        }),
      );
  }

  /**
   * Calculate a one slope roof accessories.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerOneSlopeAccessories$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerOneSlopeAccessories(
    params: {
      body: OneSlopeAccessoriesMeasurementsDto;
    },
    context?: HttpContext,
  ): Observable<Array<AccessoryDto>> {
    return this.calculationsControllerOneSlopeAccessories$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AccessoryDto>>) => r.body as Array<AccessoryDto>),
    );
  }

  /**
   * Path part for operation calculationsControllerFenceSlatCalculator
   */
  static readonly CalculationsControllerFenceSlatCalculatorPath = '/api/calculations/roof/fence-slat';

  /**
   * Calculate fence slats.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerFenceSlatCalculator()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerFenceSlatCalculator$Response(
    params: {
      body: FenceSlatDto;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<FenceSlatCalculationDto>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CalculationsService.CalculationsControllerFenceSlatCalculatorPath,
      'post',
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<FenceSlatCalculationDto>;
        }),
      );
  }

  /**
   * Calculate fence slats.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerFenceSlatCalculator$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerFenceSlatCalculator(
    params: {
      body: FenceSlatDto;
    },
    context?: HttpContext,
  ): Observable<FenceSlatCalculationDto> {
    return this.calculationsControllerFenceSlatCalculator$Response(params, context).pipe(
      map((r: StrictHttpResponse<FenceSlatCalculationDto>) => r.body as FenceSlatCalculationDto),
    );
  }

  /**
   * Path part for operation calculationsControllerFenceSlatAccessories
   */
  static readonly CalculationsControllerFenceSlatAccessoriesPath = '/api/calculations/roof/fence-slat/accessories';

  /**
   * Calculate fence slats accessories.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerFenceSlatAccessories()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerFenceSlatAccessories$Response(
    params: {
      body: FenceSlatAccessoriesMeasurementsDto;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<AccessoryDto>>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CalculationsService.CalculationsControllerFenceSlatAccessoriesPath,
      'post',
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<Array<AccessoryDto>>;
        }),
      );
  }

  /**
   * Calculate fence slats accessories.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerFenceSlatAccessories$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerFenceSlatAccessories(
    params: {
      body: FenceSlatAccessoriesMeasurementsDto;
    },
    context?: HttpContext,
  ): Observable<Array<AccessoryDto>> {
    return this.calculationsControllerFenceSlatAccessories$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AccessoryDto>>) => r.body as Array<AccessoryDto>),
    );
  }

  /**
   * Path part for operation calculationsControllerTwoSlopesCalculator
   */
  static readonly CalculationsControllerTwoSlopesCalculatorPath = '/api/calculations/roof/two-slopes';

  /**
   * Calculate a 2 slopes roof.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerTwoSlopesCalculator()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerTwoSlopesCalculator$Response(
    params: {
      body: TwoSlopeDto;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<TwoSlopeCalculationDto>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CalculationsService.CalculationsControllerTwoSlopesCalculatorPath,
      'post',
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<TwoSlopeCalculationDto>;
        }),
      );
  }

  /**
   * Calculate a 2 slopes roof.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerTwoSlopesCalculator$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerTwoSlopesCalculator(
    params: {
      body: TwoSlopeDto;
    },
    context?: HttpContext,
  ): Observable<TwoSlopeCalculationDto> {
    return this.calculationsControllerTwoSlopesCalculator$Response(params, context).pipe(
      map((r: StrictHttpResponse<TwoSlopeCalculationDto>) => r.body as TwoSlopeCalculationDto),
    );
  }

  /**
   * Path part for operation calculationsControllerFourSlopes
   */
  static readonly CalculationsControllerFourSlopesPath = '/api/calculations/roof/four-slopes';

  /**
   * Calculate a 4 slopes roof.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerFourSlopes()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerFourSlopes$Response(
    params: {
      body: FourSlope;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<FourSlopeCalculationDto>> {
    const rb = new RequestBuilder(this.rootUrl, CalculationsService.CalculationsControllerFourSlopesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<FourSlopeCalculationDto>;
        }),
      );
  }

  /**
   * Calculate a 4 slopes roof.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerFourSlopes$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerFourSlopes(
    params: {
      body: FourSlope;
    },
    context?: HttpContext,
  ): Observable<FourSlopeCalculationDto> {
    return this.calculationsControllerFourSlopes$Response(params, context).pipe(
      map((r: StrictHttpResponse<FourSlopeCalculationDto>) => r.body as FourSlopeCalculationDto),
    );
  }

  /**
   * Path part for operation calculationsControllerGenerateSketches
   */
  static readonly CalculationsControllerGenerateSketchesPath = '/api/calculations/roof/{roofType}/sketches';

  /**
   * Generate sketches.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerGenerateSketches()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerGenerateSketches$Response(
    params: {
      roofType: string;
      body: RoofDto;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<SketchesBase64Dto>> {
    const rb = new RequestBuilder(this.rootUrl, CalculationsService.CalculationsControllerGenerateSketchesPath, 'post');
    if (params) {
      rb.path('roofType', params.roofType, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<SketchesBase64Dto>;
        }),
      );
  }

  /**
   * Generate sketches.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerGenerateSketches$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerGenerateSketches(
    params: {
      roofType: string;
      body: RoofDto;
    },
    context?: HttpContext,
  ): Observable<SketchesBase64Dto> {
    return this.calculationsControllerGenerateSketches$Response(params, context).pipe(
      map((r: StrictHttpResponse<SketchesBase64Dto>) => r.body as SketchesBase64Dto),
    );
  }

  /**
   * Path part for operation calculationsControllerCustom
   */
  static readonly CalculationsControllerCustomPath = '/api/calculations/roof/custom';

  /**
   * Calculate a custom roof.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerCustom()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerCustom$Response(
    params: {
      body: CustomRoofDto;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<CustomCalculationDto>> {
    const rb = new RequestBuilder(this.rootUrl, CalculationsService.CalculationsControllerCustomPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<CustomCalculationDto>;
        }),
      );
  }

  /**
   * Calculate a custom roof.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerCustom$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerCustom(
    params: {
      body: CustomRoofDto;
    },
    context?: HttpContext,
  ): Observable<CustomCalculationDto> {
    return this.calculationsControllerCustom$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomCalculationDto>) => r.body as CustomCalculationDto),
    );
  }

  /**
   * Path part for operation calculationsControllerCustomShape
   */
  static readonly CalculationsControllerCustomShapePath = '/api/calculations/roof/custom-shape';

  /**
   * Calculate a custom shape.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerCustomShape()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerCustomShape$Response(
    params: {
      body: CustomShapeRoof;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<CustomShapeCalculationDto>> {
    const rb = new RequestBuilder(this.rootUrl, CalculationsService.CalculationsControllerCustomShapePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<CustomShapeCalculationDto>;
        }),
      );
  }

  /**
   * Calculate a custom shape.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerCustomShape$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerCustomShape(
    params: {
      body: CustomShapeRoof;
    },
    context?: HttpContext,
  ): Observable<CustomShapeCalculationDto> {
    return this.calculationsControllerCustomShape$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomShapeCalculationDto>) => r.body as CustomShapeCalculationDto),
    );
  }

  /**
   * Path part for operation calculationsControllerCustomShapeTiles
   */
  static readonly CalculationsControllerCustomShapeTilesPath = '/api/calculations/roof/custom-shape/tiles';

  /**
   * Calculate a custom shape roof tiles.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerCustomShapeTiles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerCustomShapeTiles$Response(
    params: {
      body: CustomCalculateTilesDto;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<CustomCalculateTilesResponseDto>> {
    const rb = new RequestBuilder(this.rootUrl, CalculationsService.CalculationsControllerCustomShapeTilesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<CustomCalculateTilesResponseDto>;
        }),
      );
  }

  /**
   * Calculate a custom shape roof tiles.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerCustomShapeTiles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerCustomShapeTiles(
    params: {
      body: CustomCalculateTilesDto;
    },
    context?: HttpContext,
  ): Observable<CustomCalculateTilesResponseDto> {
    return this.calculationsControllerCustomShapeTiles$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomCalculateTilesResponseDto>) => r.body as CustomCalculateTilesResponseDto),
    );
  }

  /**
   * Path part for operation calculationsControllerGetCalculation
   */
  static readonly CalculationsControllerGetCalculationPath = '/api/calculations/{id}';

  /**
   * Get a calculation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerGetCalculation()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationsControllerGetCalculation$Response(
    params: {
      id: string;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<CalculationDto>> {
    const rb = new RequestBuilder(this.rootUrl, CalculationsService.CalculationsControllerGetCalculationPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<CalculationDto>;
        }),
      );
  }

  /**
   * Get a calculation.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerGetCalculation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationsControllerGetCalculation(
    params: {
      id: string;
    },
    context?: HttpContext,
  ): Observable<CalculationDto> {
    return this.calculationsControllerGetCalculation$Response(params, context).pipe(
      map((r: StrictHttpResponse<CalculationDto>) => r.body as CalculationDto),
    );
  }
}
